import { Box, Button, Card, Flex, Grid, GridItem, Heading, Text} from '@chakra-ui/react';
import { BsPlusLg as PlusIcon } from "react-icons/bs";
import { IoEyeOutline as EyeIcon } from "react-icons/io5";
import { MdOutlineModeEditOutline as EditIcon} from "react-icons/md";
import { FaRegTrashAlt as DeleteIcon } from "react-icons/fa";
import { TopLink} from '../';

type PhotoCardDownloadDataType ={
  Id:number,
  Name:string,
  StartDate:string,
  EndDate:string,
  Date:string,
  
}


const list: PhotoCardDownloadDataType [] = [
  {
    Id:1,
    Name:'Membership Upgrade Points',
    StartDate:'12-07-24',
    EndDate:'12-08-24',
    Date:'11-04-23'
  }
  
]


const PhotocardDownload = () => {
  return (
    <Box>
      <TopLink />
      <Flex justify="space-between" align="center" mt="20px">
        <Heading m="0" fontSize="1.5rem" color="var(--dark-green-color)">PhotoCard SetUp</Heading>
        {/* <Button colorScheme='green' leftIcon={<PlusIcon />}>Add Fee</Button> */}
      </Flex>
      <Grid templateColumns={'repeat(2,.6fr)'} gap="20px" mt="20px">

       { list.map(({Id,Name,Date}:PhotoCardDownloadDataType) => 
       <Card key={Id} as ={GridItem} p="20px" display="flex" gap="10px" justify="space-between" flexDir="row" >
            <Flex flexDir="column" gap="3px">
              <Text m="0">{Name}</Text>
              <Text m="0">Start Date {Date}</Text>
              <Text m="0">End Date {Date}</Text>
              <Text m="0">Created {Date}</Text>
            </Flex>
            <Flex alignSelf="center" gap="10px" align="center" fontSize="1.2rem">
              <EyeIcon style={{cursor:'pointer'}}/>
              <EditIcon style={{cursor:'pointer'}} />
              <DeleteIcon style={{cursor:'pointer'}} />
            </Flex>
        </Card>)}
      </Grid>
      
    </Box>
  )
}

export default PhotocardDownload